<kehe-phoenix-modal
  [show]="true"
  name="add-transaction-type-modal"
  modalTitle="{{ editMode ? 'Edit Transaction Type' : 'Add Transaction Type' }}"
  (modalEvent)="handleModalEvents($event)"
  (closeEvent)="handleCloseModal()"
  size="md"
>
  @if (addTransactionTypeForm) {
    <div class="row mx-0" body [formGroup]="addTransactionTypeForm.form">
      <div class="px-0">
        @if (formErrorsHtml) {
          <kehe-phoenix-alert
            [show]="true"
            type="error"
            stick="true"
            [hideCloseIcon]="true"
            [messageAsHtml]="formErrorsHtml"
          ></kehe-phoenix-alert>
        }
        @if (vm$ | async; as vm) {
          <kehe-phoenix-alert
            [show]="vm.hasError"
            type="error"
            stick="true"
            [hideCloseIcon]="true"
            [messageAsHtml]="vm.errorMessage"
          ></kehe-phoenix-alert>
        }
      </div>
      <h5 class="ps-0">Transaction Type Information</h5>
      <div class="col-md-12 px-0">
        <div class="form-group">
          <kendo-formfield>
            <kendo-label
              class="modal-info-label"
              text="Transaction Type Description"
            ></kendo-label>
            <kendo-textbox
              placeholder="Enter Transaction Type Description"
              data-automation-id="add-transaction-type-description"
              formControlName="transactionTypeDescription"
              [maxlength]="defaultMaxLength"
            >
            </kendo-textbox>
            @if (
              addTransactionTypeForm.form?.get('transactionTypeDescription')
                ?.errors?.required
            ) {
              <kendo-formerror
                >Transaction Type Description is required.</kendo-formerror
              >
            }
          </kendo-formfield>
        </div>
      </div>

      <div class="col-md-12 px-0">
        <div class="form-group">
          <kendo-formfield>
            <kendo-label
              class="modal-info-label"
              text="Invoice Header Description"
            ></kendo-label>
            <kendo-textbox
              placeholder="Enter Invoice Header Description"
              data-automation-id="add-transaction-type-invoice-header-description"
              formControlName="invoiceHeaderDescription"
              [maxlength]="defaultMaxLength"
            >
            </kendo-textbox>
            @if (
              addTransactionTypeForm.form?.get('invoiceHeaderDescription')
                ?.errors?.required
            ) {
              <kendo-formerror
                >Invoice Header Description is required.</kendo-formerror
              >
            }
          </kendo-formfield>
        </div>
      </div>

      <div class="col-md-12 px-0">
        <div class="form-group">
          <kendo-formfield>
            <kendo-label
              class="modal-info-label"
              text="Invoice Prefix"
            ></kendo-label>
            <kendo-textbox
              placeholder="Enter Invoice Prefix"
              data-automation-id="add-transaction-type-invoice-prefix"
              formControlName="invoicePrefix"
              [maxlength]="invoicePrefixMaxLength"
              (valueChange)="handleInvoicePrefixValueChange($event)"
            >
              <ng-template kendoTextBoxSuffixTemplate>
                <span
                  >{{ invoicePrefixCharacterCount }}/{{
                    invoicePrefixMaxLength
                  }}</span
                >
              </ng-template>
            </kendo-textbox>
            @if (
              addTransactionTypeForm.form?.get('invoicePrefix')?.errors
                ?.required
            ) {
              <kendo-formerror>Invoice Prefix is required.</kendo-formerror>
            }
            @if (
              addTransactionTypeForm.form?.get('invoicePrefix')?.errors
                ?.duplicate
            ) {
              <kendo-formerror>Invoice Prefix already exists.</kendo-formerror>
            }
            @if (
              addTransactionTypeForm.form?.get('invoicePrefix')?.errors
                ?.nonAlphaNumeric
            ) {
              <kendo-formerror
                >Invoice Prefix must be alphanumeric.</kendo-formerror
              >
            }
          </kendo-formfield>
        </div>
      </div>

      @if (isHandKeyFFEnabled) {
        <div class="col-md-12 px-0">
          <div class="form-group">
            <kendo-label
              text="Is this Hand Key?"
              for="isHandKey"
              data-automation-id="is-handKey-label"
            ></kendo-label>
            @if (editMode) {
              <kendo-formhint class="mt-0"
                >This field cannot be edited.</kendo-formhint
              >
            } @else if (hasRequiredError('isHandKey')) {
              <kendo-formerror class="mt-0">
                Field is required.
              </kendo-formerror>
            }
            <ul class="k-radio-list">
              <li class="k-radio-item">
                <input
                  class="k-radio"
                  type="radio"
                  formControlName="isHandKey"
                  data-automation-id="handKey-true"
                  #handKeyTrue
                  kendoRadioButton
                  [value]="true"
                  (change)="onHandKeyChange()"
                />
                <kendo-label
                  class="k-radio-label"
                  [for]="handKeyTrue"
                  text="Yes"
                ></kendo-label>
              </li>

              <li class="k-radio-item">
                <input
                  class="k-radio"
                  type="radio"
                  formControlName="isHandKey"
                  data-automation-id="handKey-false"
                  #handKeyFalse
                  kendoRadioButton
                  [value]="false"
                  (change)="onHandKeyChange()"
                />
                <kendo-label
                  class="k-radio-label"
                  [for]="handKeyFalse"
                  text="No"
                ></kendo-label>
              </li>
            </ul>
          </div>
        </div>
      }

      <div class="col-md-12 px-0">
        <div class="form-group">
          <kendo-label
            text="How is the invoice identified?"
            for="isUpcIdentified"
            data-automation-id="is-upc-identified-label"
          ></kendo-label>
          @if (hasRequiredError('isUpcIdentified')) {
            <kendo-formerror class="mt-0">Field is required. </kendo-formerror>
          }
          <ul class="k-radio-list">
            <li class="k-radio-item">
              <input
                class="k-radio"
                type="radio"
                formControlName="isUpcIdentified"
                data-automation-id="isupcidentified-true"
                #isUpcIdentifiedTrue
                kendoRadioButton
                (valueChange)="onIsUpcIdentifiedChange($event)"
                [value]="true"
              />
              <kendo-label
                class="k-radio-label"
                [for]="isUpcIdentifiedTrue"
                text="UPC"
              ></kendo-label>
            </li>

            <li class="k-radio-item">
              <input
                class="k-radio"
                type="radio"
                formControlName="isUpcIdentified"
                data-automation-id="isupcidentified-false"
                #isUpcIdentifiedFalse
                kendoRadioButton
                (valueChange)="onIsUpcIdentifiedChange($event)"
                [value]="false"
              />
              <kendo-label
                class="k-radio-label"
                [for]="isUpcIdentifiedFalse"
                text="ESN"
              ></kendo-label>
            </li>
          </ul>
        </div>
      </div>

      @if (!isHandKey) {
        <div class="col-md-12 px-0">
          <div class="form-group">
            <kendo-formfield>
              <kendo-label text="Retailer (Cost Center)"></kendo-label>
              <kendo-combobox
                data-automation-id="add-transaction-type-cost-center"
                formControlName="costCenter"
                [data]="costCenters"
                placeholder="Select Cost Center"
                [filterable]="true"
                (filterChange)="handleCostCenterFilter($event)"
                textField="codeValue"
                valueField="code"
                [valuePrimitive]="true"
                [loading]="loadingCostCenters"
                (valueChange)="costCenterValueChange($event)"
              >
              </kendo-combobox>
              @if (
                addTransactionTypeForm.form?.get('costCenter')?.errors?.required
              ) {
                <kendo-formerror>Cost Center is required.</kendo-formerror>
              }
            </kendo-formfield>
          </div>
        </div>
      }

      @if (vm$ | async; as vm) {
        <div class="col-md-12 px-0">
          <div class="form-group">
            <kendo-formfield>
              <kendo-label
                [for]="spendCategory"
                text="Spend Category"
              ></kendo-label>
              <kendo-combobox
                #spendCategory
                (focus)="
                  vm.spendCategoryDataSource.length > 0 &&
                    spendCategory.toggle(true)
                "
                formControlName="spendCategory"
                (valueChange)="spendCategoryValueChange($event)"
                [data]="vm.spendCategoryDataSource"
                [textField]="'value'"
                [valueField]="'codeValue'"
                [valuePrimitive]="true"
                [filterable]="true"
                [attr.data-automation-id]="'add-transaction-type-spend-category-selection'"
                [kendoDropDownFilter]="{ operator: 'contains' }"
                placeholder="Select Spend Category"
              >
              </kendo-combobox>
              @if (
                addTransactionTypeForm.form?.get('spendCategory')?.errors
                  ?.required
              ) {
                <kendo-formerror>Spend Category is required.</kendo-formerror>
              }
            </kendo-formfield>
          </div>
        </div>
      }

      @if (!isHandKey) {
        <div class="row">
          <div class="col-md-12 px-0">
            <div class="form-group">
              <kendo-label
                text="How are these invoices being billed by?"
                for="invoiceType"
                data-automation-id="invoice-type-label"
              ></kendo-label>

              @if (hasRequiredError('invoiceType')) {
                <kendo-formerror class="mt-0">
                  Bill by type is required.
                </kendo-formerror>
              }

              <ul class="k-radio-list">
                <li class="k-radio-item">
                  <input
                    class="k-radio"
                    type="radio"
                    formControlName="invoiceType"
                    data-automation-id="invoice-type-esn-true"
                    #invoiceTypeEsn
                    kendoRadioButton
                    [value]="true"
                  />
                  <kendo-label
                    class="k-radio-label"
                    [for]="invoiceTypeEsn"
                    text="Bill by ESN"
                  ></kendo-label>
                </li>

                <li class="k-radio-item">
                  <input
                    class="k-radio"
                    type="radio"
                    formControlName="invoiceType"
                    data-automation-id="invoice-type-dc-product-group-false"
                    #invoiceTypeDc
                    kendoRadioButton
                    [value]="false"
                  />
                  <kendo-label
                    class="k-radio-label"
                    [for]="invoiceTypeDc"
                    text="Bill by DC Product Group"
                  ></kendo-label>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="col-md-12 px-0">
          <div class="form-group">
            <kendo-formfield>
              <kendo-label class="modal-info-label" text="Chain"></kendo-label>
              <kendo-textbox
                placeholder="Enter Chain"
                data-automation-id="add-transaction-type-chain"
                formControlName="chain"
                [maxlength]="defaultMaxLength"
              >
              </kendo-textbox>
              @if (
                addTransactionTypeForm.form?.get('chain')?.errors?.required
              ) {
                <kendo-formerror>Chain is required.</kendo-formerror>
              }
            </kendo-formfield>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 px-0">
            <div class="form-group">
              <kendo-label
                text="Include supporting educational documents?"
                for="hasSupportingDocument"
                data-automation-id="has-supporting-document-type-label"
              ></kendo-label>

              @if (hasRequiredError('hasSupportingDocument')) {
                <kendo-formerror class="mt-0"
                  >Field is required.
                </kendo-formerror>
              }

              <ul class="k-radio-list">
                <li class="k-radio-item">
                  <input
                    class="k-radio"
                    type="radio"
                    formControlName="hasSupportingDocument"
                    (change)="onHasSupportingDocumentChange($event)"
                    data-automation-id="has-supporting-document-type-true"
                    #hasSupportingDocumentTrue
                    kendoRadioButton
                    [value]="true"
                  />
                  <kendo-label
                    class="k-radio-label"
                    [for]="hasSupportingDocumentTrue"
                    text="Yes"
                  ></kendo-label>
                </li>

                <li class="k-radio-item">
                  <input
                    class="k-radio"
                    type="radio"
                    formControlName="hasSupportingDocument"
                    (change)="onHasSupportingDocumentChange($event)"
                    data-automation-id="has-supporting-document-type-false"
                    #hasSupportingDocumentFalse
                    kendoRadioButton
                    [value]="false"
                  />
                  <kendo-label
                    class="k-radio-label"
                    [for]="hasSupportingDocumentFalse"
                    text="No"
                  ></kendo-label>
                </li>
              </ul>
            </div>
          </div>
        </div>

        @if (
          addTransactionTypeForm.form?.get('hasSupportingDocument')?.value ===
          true
        ) {
          <div class="col-md-12 px-0">
            <div class="form-group">
              <kendo-label text="Upload Supporting Documents"></kendo-label>
              <kendo-formhint
                >File must be .pdf and no more than 5 MB.</kendo-formhint
              >
              <kehe-phoenix-upload
                formControlName="supportingDocumentFile"
                data-automation-id="supporting-document-file-upload-input"
                [fileUploads]="supportingDocumentFileUploads"
                [uploadRestrictions]="supportingDocumentUploadRestrictions"
                (addFiles)="handleSupportingDocumentFiles($event)"
                [allowMultipleSelect]="false"
                (removeFiles)="handleRemoveSupportingDocumentFiles($event)"
                (blur)="onBlurEvent()"
              >
              </kehe-phoenix-upload>
            </div>
          </div>
        }
      }
      <div class="row">
        <div class="col-md-12 px-0">
          <div class="form-group">
            <kendo-label
              text="Is there an EP Fee?"
              for="hasEpFee"
              data-automation-id="has-ep-fee-label"
            ></kendo-label>

            @if (hasRequiredError('hasEpFee')) {
              <kendo-formerror class="mt-0"
                >Field is required.
              </kendo-formerror>
            }

            <ul class="k-radio-list">
              <li class="k-radio-item">
                <input
                  class="k-radio"
                  type="radio"
                  formControlName="hasEpFee"
                  data-automation-id="has-ep-fee-type-true"
                  #hasEpFeeTrue
                  kendoRadioButton
                  [value]="true"
                />
                <kendo-label
                  class="k-radio-label"
                  [for]="hasEpFeeTrue"
                  text="Yes"
                ></kendo-label>
              </li>

              <li class="k-radio-item">
                <input
                  class="k-radio"
                  type="radio"
                  formControlName="hasEpFee"
                  data-automation-id="has-ep-fee-type-false"
                  #hasEpFeeFalse
                  kendoRadioButton
                  [value]="false"
                />
                <kendo-label
                  class="k-radio-label"
                  [for]="hasEpFeeFalse"
                  text="No"
                ></kendo-label>
              </li>
            </ul>
          </div>
        </div>
      </div>

      @if (!isHandKey) {
        <div class="col-md-12 px-0">
          <div class="form-group">
            <h5>Customize your Template</h5>
            <p>
              Download the base template file and add your column headers. This
              information will populate in the generated invoices.
            </p>
            <kendo-label text="Upload Custom Template"></kendo-label>
            <kendo-formhint
              >File must be xlsx. and no more than 5 MB.</kendo-formhint
            >
            <kehe-phoenix-upload-control
              formControlName="fileUpload"
              data-automation-id="add-transaction-type-file-upload-input"
              [fileUploads]="fileUploads"
              [uploadRestrictions]="uploadRestrictions"
              (addFiles)="handleAddFiles($event)"
              [allowMultipleSelect]="false"
              (removeFiles)="handleRemoveFiles($event)"
              (blur)="onBlurEvent()"
            >
            </kehe-phoenix-upload-control>
            <a
              class="link"
              (click)="
                addTransactionTypeForm.form.controls.isUpcIdentified.value ===
                null
                  ? $event.preventDefault()
                  : downloadTemplate()
              "
              [class.disabled]="
                addTransactionTypeForm.form.controls.isUpcIdentified.value !==
                  true &&
                addTransactionTypeForm.form.controls.isUpcIdentified.value !==
                  false
              "
              [attr.aria-disabled]="
                addTransactionTypeForm.form.controls.isUpcIdentified.value ===
                null
              "
            >
              Download Base Template
            </a>
          </div>
        </div>
      }
    </div>
  }

  <div footer class="d-flex justify-content-end">
    <kehe-phoenix-button
      classAttr="btn-medium btn-link"
      class="me-2"
      (click)="handleModalEvents({ type: 'close' })"
    >
      Cancel
    </kehe-phoenix-button>
    @if (vm$ | async; as vm) {
      <kehe-phoenix-button
        classAttr="btn-primary btn-medium"
        [disabled]="
          addTransactionTypeForm.form?.invalid ||
          !addTransactionTypeForm.form.dirty ||
          hasDuplicateError
        "
        [spinner]="vm.isSaving"
        (click)="save()"
      >
        {{ editMode ? 'Save' : 'Add' }}
      </kehe-phoenix-button>
    }
  </div>
</kehe-phoenix-modal>
